import React, { useCallback } from "react";
import { useLocation } from "react-router-dom";
import { STATUS } from "../const";
import { allPaymentMode } from "components/allForm/PurchaseItem/selectedOptions";
import { fetchExportExpenseApi } from "api/expense";
import { useToasts } from "react-toast-notifications";
const moment = require("moment");

const useExpenseExport = (role) => {
  const location = useLocation();
  const pathSegments = location.pathname.split("/");
  const id = pathSegments[pathSegments.length - 1];
  const { addToast } = useToasts();

  const handleExportExpenseApi = useCallback(
    async (dates = {}) => {
      const bodyData = {
        role: role,
        startDate: dates?.startDate || new Date().toISOString(),
        endDate: dates?.endDate || new Date().toISOString(),
      };

      try {
        const response = await fetchExportExpenseApi(id, bodyData);
        console.log("response", response);

        return response?.data || response;
      } catch (error) {
        console.error("API error while exporting invoice datasets:", error);
        throw error;
      }
    },
    [id, role],
  );
  const mainCols = [
    {
      columnName: "PO ID",
      name: "poNo",
    },
    {
      columnName: "Tax Period",
      name: "oM",
    },

    {
      columnName: "Order Date",
      name: "oDt",
    },

    {
      columnName: "Client Name",
      name: "cId",
    },
    {
      columnName: "Project Name",
      name: "pId",
    },
    {
      columnName: "Location",
      name: "ofcId",
    },
    {
      columnName: "Primary Category",
      name: "mjId",
    },

    {
      columnName: "Secondary Category",
      name: "mnId",
    },
    {
      columnName: "Sub-Category",
      name: "subMnId",
    },
    {
      columnName: "Remarks",
      name: "rmks",
    },

    {
      columnName: "Vendor Name",
      name: "vId",
    },
    {
      columnName: "GSTIN",
      name: "gstNo",
    },
    {
      columnName: "Currency",
      name: "cur",
    },
    {
      columnName: "Payment Terms",
      name: "pymtTerms",
    },

    {
      columnName: "Status",
      name: "sts",
    },
    {
      columnName: "Status Date",
      name: "stsDate",
    },
    {
      columnName: "Adjustment",
      name: "adjAmt",
    },
  ];

  const childSheets = {
    items: {
      sheetTitle: "Line Items",
      sheetKey: "items",
      firstColumn: {
        columnName: "PO ID",
        name: "poNo",
      },
      cols: [
        {
          columnName: "Product / Service",
          name: "salesItemId",
        },
        {
          columnName: "Name",
          name: "name",
        },
        {
          columnName: "HSN/SAC",
          name: "code",
        },
        {
          columnName: "Specifications",
          name: "des",
        },
        {
          columnName: "Qty",
          name: "qty",
        },
        {
          columnName: "Unit Price",
          name: "prc",
        },
        {
          columnName: "GST",
          name: "txPrc",
        },
        {
          columnName: "TDS",
          name: "tdsPrc",
        },
        {
          columnName: "Total",
          name: "total",
        },
      ],
    },
    payments: {
      sheetTitle: "Payments",
      sheetKey: "payments",
      firstColumn: {
        columnName: "PO ID",
        name: "poNo",
      },
      cols: [
        {
          columnName: "Payment number",
          name: "pmtNo",
        },
        {
          columnName: "Payment Date",
          name: "reqDt",
        },

        {
          columnName: "Payee",
          name: "payee",
        },

        {
          columnName: "Bank Name",
          name: "orgBankName",
        },
        {
          columnName: "Quotation",
          name: "quoNum",
        },
        {
          columnName: "Amount",
          name: "quoAmt",
        },
        {
          columnName: "Proforma Invoice",
          name: "pfNum",
        },
        {
          columnName: "Amount",
          name: "amt",
        },
        {
          columnName: "Due Date",
          name: "duDt",
        },
        {
          columnName: "Remarks",
          name: "rmks",
        },
        {
          columnName: "Status",
          name: "sts",
        },
        {
          columnName: "Modified Date",
          name: "stsDate",
        },
      ],
    },
    quotations: {
      sheetTitle: "Quotation Registry",
      sheetKey: "quotations",
      firstColumn: {
        columnName: "PO ID",
        name: "poNo",
      },
      cols: [
        {
          columnName: "Internal Quote ID",
          name: "orgQuoNum",
        },
        {
          columnName: "Date",
          name: "orgQuoDt",
        },
        {
          columnName: "Vendor Quote ID",
          name: "vndQuoNum",
        },
        {
          columnName: "Date",
          name: "vndQuoDt",
        },
        {
          columnName: "Quote Amount",
          name: "amt",
        },

        {
          columnName: "Credit Period",
          name: "trms",
        },
        {
          columnName: "Remarks",
          name: "nts",
        },
        {
          columnName: "Quote Copy",
          name: "quoAttach",
        },

        {
          columnName: "Upload Date",
          name: "quoFileDt",
        },

        {
          columnName: "Approval Status",
          name: "sts",
        },
        {
          columnName: "Modified Date",
          name: "stsDate",
        },
      ],
    },

    inv: {
      sheetTitle: "Invoice Registry",
      sheetKey: "inv",
      firstColumn: {
        columnName: "PO ID",
        name: "poNo",
      },
      cols: [
        {
          columnName: "PI Number",
          name: "pfNo",
        },
        {
          columnName: "Proforma Invoice Date",
          name: "pfDt",
        },
        {
          columnName: "PI Copy",
          name: "pfFile",
        },
        {
          columnName: "Upload Date",
          name: "pfFileDt",
        },
        {
          columnName: "PI Status",
          name: "pfSts",
        },
        {
          columnName: "Tax Invoice Number",
          name: "invNo",
        },

        {
          columnName: "Invoice Date",
          name: "invFile",
        },
        {
          columnName: "Upload Date",
          name: "invFileDt",
        },
        {
          columnName: "Verification Status",
          name: "invSts",
        },
        {
          columnName: "Invoice Amount",
          name: "amt",
        },
        {
          columnName: "Remarks",
          name: "invRmks",
        },
      ],
    },

    taxes: {
      sheetTitle: "Tax",
      sheetKey: "taxes",
      firstColumn: {
        columnName: "PO ID",
        name: "poNo",
      },
      cols: [
        {
          columnName: "Item Information",
          name: "des",
        },
        {
          columnName: "Taxable Amount",
          name: "txAmt",
        },
        {
          columnName: "IGST",
          name: "igst",
        },
        {
          columnName: "CGST",
          name: "cgst",
        },
        {
          columnName: "SGST",
          name: "sgst",
        },
        {
          columnName: "Total",
          name: "ttlGst",
        },
      ],
    },
    tds: {
      sheetTitle: "TDS",
      sheetKey: "tds",
      firstColumn: {
        columnName: "PO ID",
        name: "poNo",
      },
      cols: [
        {
          columnName: "Item Description",
          name: "des",
        },
        {
          columnName: "Taxable Amount",
          name: "txAmt",
        },
        {
          columnName: "TDS (%)",
          name: "tds",
        },
        {
          columnName: "TDS Amount",
          name: "ttlTds",
        },
      ],
    },
    credits: {
      sheetTitle: "Credits",
      sheetKey: "credits",
      firstColumn: {
        columnName: "PO ID",
        name: "poNo",
      },
      cols: [
        {
          columnName: "Credit Note",
          name: "crId",
        },
        {
          columnName: "Credit Date",
          name: "creditDt",
        },
        {
          columnName: "Credit Id",
          name: "crNo",
        },
        {
          columnName: "Available Amount",
          name: "avAmt",
        },
        {
          columnName: "Remaining Amount",
          name: "rmAmt",
        },
        {
          columnName: "Utilized Amount",
          name: "usAmt",
        },

        {
          columnName: "Utilized Date",
          name: "utilizedDt",
        },
        {
          columnName: "Attachment",
          name: "expCrAttach",
        },
        {
          columnName: "Attachment Date",
          name: "expCrAttachDt",
        },

        {
          columnName: "Status",
          name: "sts",
        },
        {
          columnName: "Status Date",
          name: "stsDate",
        },
        {
          columnName: "Remarks",
          name: "remarks",
        },
      ],
    },

    refunds: {
      sheetTitle: "Refunds",
      sheetKey: "refunds",
      firstColumn: {
        columnName: "PO ID",
        name: "poNo",
      },
      cols: [
        {
          columnName: "Refund Details",
          name: "rfNo",
        },
        {
          columnName: "Refund Date",
          name: "rfDt",
        },
        {
          columnName: "Amount",
          name: "amt",
        },
        {
          columnName: "Payment mode",
          name: "mod",
        },
        {
          columnName: "Payment Date",
          name: "payDt",
        },
        {
          columnName: "Reference No.",
          name: "refNo",
        },
        {
          columnName: "Reason",
          name: "reason",
        },
        {
          columnName: "Attachment",
          name: "expRefAttach",
        },
        {
          columnName: "Upload Date",
          name: "expRfAttachDt",
        },
        {
          columnName: "Status",
          name: "sts",
        },
        {
          columnName: "Status Date",
          name: "stsDate",
        },
      ],
    },
    freightExpense: {
      sheetTitle: "Freight Expense",
      sheetKey: "freightExpense",
      firstColumn: {
        columnName: "PO ID",
        name: "poNo",
      },
      cols: [
        {
          columnName: "Delivery Partner",
          name: "agency",
        },
        {
          columnName: "Tracking Number",
          name: "trkNo",
        },
      ],
    },
    reimbursementInfo: {
      sheetTitle: "Reimbursement Information",
      sheetKey: "reimbursementInfo",
      firstColumn: {
        columnName: "PO ID",
        name: "poNo",
      },
      cols: [
        {
          columnName: "Invoice Number",
          name: "inNo",
        },
        {
          columnName: "Invoice Date",
          name: "inDt",
        },
        {
          columnName: "Payment Date",
          name: "pmtDt",
        },
        {
          columnName: "Currency",
          name: "cur",
        },
        {
          columnName: "Amount",
          name: "amt",
        },
        {
          columnName: "Conversion Rate",
          name: "cnvRt",
        },
        {
          columnName: "Amount in INR",
          name: "inr",
        },
      ],
    },
  };

  const handleGetFreshColumns = useCallback(
    async (dateFilters) => {
      const apiResponse = await handleExportExpenseApi(dateFilters);
      const rawRecords = Array.isArray(apiResponse)
        ? apiResponse
        : apiResponse?.customExpense || [];

      if (rawRecords.length === 0) {
        addToast(
          `No expense records were found for the specified date range.`,
          {
            appearance: "error",
          },
        );

        return;
      }

      // Map complex nested structure fields to match mainCols keys
      const flattenedRecords = rawRecords.map((record) => {
        const poNo =
          record.poNo && record.poNo.n
            ? `${record.poNo.prfx || ""}${String(record.poNo.m).padStart(2, "0")}${String(record.poNo.y).slice(-2)}-${String(record.poNo.n).padStart(2, "0")}`
            : "";

        // Normalize line items array location from inside record.pyInfo.itms
        const rawItms = record.pyInfo?.itms || record.items || [];

        const formattedItems = rawItms.map((item) => ({
          parent: item.parent,
          salesItemId: item.slItm?.name || "",
          name: item.slItm?.name || "",
          code: item.slItm?.hCd || "",
          des: item.slItm?.dc || "",
          qty: item.qty !== undefined ? item.qty : "",
          prc: item.prc !== undefined ? item.prc : "",
          txPrc: item.tax?.percentage || "",
          tdsPrc: item.tdsPrc || "",
          total: item.amt !== undefined ? item.amt : "",
        }));

        const getPaymentMode = (id) => {
          const payMod = allPaymentMode.find((opt) => opt.id === id);
          return payMod?.value || "";
        };

        // 1. Safe extraction of the main container object
        const pyInfoObj =
          record.pyInfo && !Array.isArray(record.pyInfo) ? record.pyInfo : {};

        // 2. FIXED: Target the actual array matching your JSON structure (pyInfo.list, pyInfo itself, or fallback payments)
        const nestedPayments = Array.isArray(pyInfoObj.list)
          ? pyInfoObj.list
          : Array.isArray(record.pyInfo)
            ? record.pyInfo
            : Array.isArray(record.payments)
              ? record.payments
              : [];

        // 3. Transform array items into frontend table/state rows
        const formattedPayments = nestedPayments.map((pmt) => {
          // Compute Payment Number cleanly
          let computedPmtNo = "";
          if (pmt.pyNo && typeof pmt.pyNo === "object") {
            const mm = String(pmt.pyNo.m || "").padStart(2, "0");
            const yy = String(pmt.pyNo.y || "").slice(-2);
            const nn = String(pmt.pyNo.n || "").padStart(2, "0");
            computedPmtNo = `${pmt.pyNo.prfx || ""}${mm}${yy}-${nn}`;
          } else if (pmt.pNo) {
            computedPmtNo = pmt.pNo;
          } else if (pyInfoObj.pNo) {
            computedPmtNo = pyInfoObj.pNo;
          } else if (pmt.refNo) {
            // Fallback: Maps "SK_REF" directly from your payload structural match
            computedPmtNo = pmt.refNo;
          }

          // Resolve status string cleanly using safely scoped fallbacks
          const resolvedSts =
            pyInfoObj.sts !== undefined
              ? STATUS[pyInfoObj.sts] || ""
              : pmt.sts !== undefined
                ? STATUS[pmt.sts] || ""
                : "";

          // Helper handling for your exact nested BSON $date structure
          const rawDate = pmt.pmtDt || pmt.dt;
          const rawPyInfoDate =
            pyInfoObj.pDt && pyInfoObj.pDt.$date
              ? pyInfoObj.pDt.$date
              : pyInfoObj.pDt;

          return {
            parent: pmt.parent || pyInfoObj.parent || "",

            pmtNo: computedPmtNo,
            payee: pmt.pyId?.lab,
            orgBankName: pmt.bnkId?.lab,

            // Safely handles both regular ISO strings and Mongo $date objects
            reqDt: rawDate ? moment(rawDate).format("DD-MM-YYYY") : "",

            amt: pmt.amt !== undefined ? pmt.amt : "",

            bnkCrg: pmt.crg !== undefined ? pmt.crg : "",

            ttlTds: pmt.ttlTds !== undefined ? pmt.ttlTds : "",

            mod: pmt.mod !== undefined ? getPaymentMode(pmt.mod) : "",

            payModDt: rawPyInfoDate
              ? moment(rawPyInfoDate).format("DD-MM-YYYY")
              : "",

            ref: pmt.ref || pmt.refNo || "",

            sts: resolvedSts,

            stsDate: pmt.stsDate
              ? moment(pmt.stsDate).format("DD-MM-YYYY")
              : "",
          };
        });

        const resolvedParentId = poNo;

        const rawRefunds = record.rfdInfo?.list || [];
        const nestedRefunds = Array.isArray(rawRefunds)
          ? rawRefunds
          : [rawRefunds];

        const formattedRefunds = nestedRefunds
          .map((rf) => {
            if (!rf || typeof rf !== "object") return null;

            const computedParent = rf.parent || resolvedParentId;
            const rawRfDate = rf.rfDate || rf.pmtDt || "";
            const rwaPyDate = rf.pmtDt || rf.pymtRxDate || rf.rfDate || "";

            return {
              poNo: computedParent,
              parent: computedParent,
              refNo: rf.rfNo || "",
              rfDt: moment(rawRfDate).format("DD-MM-YYYY") || "",
              amt: rf.amt !== undefined ? rf.amt : "",
              mod: rf.moId
                ? getPaymentMode(rf.moId)
                : rf.mod
                  ? getPaymentMode(rf.mod)
                  : "",
              payDt: moment(rwaPyDate).format("DD-MM-YYYY") || "",
              ref: rf.rfNo || "",
              rsn: rf.rsn || "",
              invRfAttach: rf.invRfAttach || "",
              invRfAttachDt: rf.invRfAttachDt || "",
              sts: rf.sts !== undefined ? STATUS[rf.sts] || rf.sts : "",
              stsDate: rf.stsDate || "",
            };
          })
          .filter(Boolean);

        const rawTds =
          record.tdsApl?.tdsRc || record.tds || record.pyInfo?.tds || [];
        const nestedTds = Array.isArray(rawTds) ? rawTds : [rawTds];

        const formattedTds = nestedTds
          .map((t) => {
            if (!t || typeof t !== "object") return null;
            return {
              poNo: resolvedParentId,
              parent: resolvedParentId,
              des: t.des || "TDS Deduction",
              txAmt:
                t.bsAmt !== undefined
                  ? t.bsAmt
                  : t.txAmt !== undefined
                    ? t.txAmt
                    : "",
              tds:
                t.prc !== undefined ? t.prc : t.tds !== undefined ? t.tds : "",
              ttlTds:
                t.tdsAmt !== undefined
                  ? t.tdsAmt
                  : t.ttlTds !== undefined
                    ? t.ttlTds
                    : "",
            };
          })
          .filter(Boolean);

        const rawCredits =
          record.credits || record.crApl?.list || record.pyInfo?.credits || [];
        const nestedCredits = Array.isArray(rawCredits)
          ? rawCredits
          : [rawCredits];

        const formattedCredits = nestedCredits
          .map((item) => {
            if (!item || typeof item !== "object") return null;

            const crObj =
              item.crId && typeof item.crId === "object" ? item.crId : {};

            let computedCrNo = "";
            if (crObj.crNo && typeof crObj.crNo === "object") {
              const mm = String(crObj.crNo.m || "").padStart(2, "0");
              const yy = String(crObj.crNo.y || "").slice(-2);
              const nn = String(crObj.crNo.n || "").padStart(2, "0");
              computedCrNo = `${crObj.crNo.prfx || ""}${mm}${yy}-${nn}`;
            }

            const computedParent =
              item.parent || record.parent || resolvedParentId;
            const rawPaymentDate = crObj.pmtDt || crObj.crAt || "";

            const rawUsedDate = item.upAt || crObj.upAt || "";
            return {
              poNo: computedParent,
              parent: computedParent,
              crId: "",
              crDate: moment(rawPaymentDate).format("DD-MM-YYYY") || "",
              crNo: computedCrNo,
              avAmt: crObj.amt !== undefined ? crObj.amt : "",
              usAmt:
                item.usAmt !== undefined
                  ? item.usAmt
                  : crObj.usAmt !== undefined
                    ? crObj.usAmt
                    : "",
              usDate: moment(rawUsedDate).format("DD-MM-YYYY") || "",
              invCrAttach: crObj.fils?.key || "",
              invCrAttachDt: crObj.invCrAttachDt || "",
              creditRmks: crObj.rmks || "",
              sts:
                record.crApl?.sts !== undefined
                  ? record.crApl.sts
                    ? "approved"
                    : "rejected"
                  : "",
              stsDate: item.stsDate || "",
            };
          })
          .filter(Boolean);

        const rawTaxes =
          record.gstRc || record.taxes || record.pyInfo?.taxes || [];
        const nestedTaxes = Array.isArray(rawTaxes) ? rawTaxes : [rawTaxes];

        const formattedTaxes = nestedTaxes
          .map((t) => {
            if (!t || typeof t !== "object") return null;
            const igstVal = t.amt?.i !== undefined ? t.amt.i : 0;
            const cgstVal = t.amt?.c !== undefined ? t.amt.c : 0;
            const sgstVal = t.amt?.s !== undefined ? t.amt.s : 0;
            const totalGstVal = igstVal + cgstVal + sgstVal;

            return {
              poNo: resolvedParentId,
              parent: resolvedParentId,
              des: t.des || "GST Tax Entry",
              txAmt:
                t.bsAmt !== undefined
                  ? t.bsAmt
                  : t.txAmt !== undefined
                    ? t.txAmt
                    : "",
              igst: igstVal,
              cgst: cgstVal,
              sgst: sgstVal,
              ttlGst: t.ttlGst !== undefined ? t.ttlGst : totalGstVal,
            };
          })
          .filter(Boolean);

        const formattedInvoice = record?.pyInfo?.blNo?.toString().trim()
          ? [
              {
                parent: resolvedParentId,
                pfNo: record.pyInfo.blNo,
              },
            ]
          : [];

        const formattedFreight = record?.exp?.trkNo?.toString().trim()
          ? [
              {
                parent: resolvedParentId,
                agency: record?.exp?.adId?.lab || "",
                trkNo: record.exp.trkNo,
              },
            ]
          : [];

        const rmbInfoObj =
          record.rmbInfo && typeof record.rmbInfo === "object"
            ? record.rmbInfo
            : {};

        const isRmbObj =
          rmbInfoObj.isRmb && typeof rmbInfoObj.isRmb === "object"
            ? rmbInfoObj.isRmb
            : null;

        const formattedReimbursement =
          isRmbObj?.sts === true
            ? [
                {
                  poNo:
                    isRmbObj.parent ||
                    rmbInfoObj.parent ||
                    record.parent ||
                    resolvedParentId ||
                    "",

                  parent:
                    isRmbObj.parent ||
                    rmbInfoObj.parent ||
                    record.parent ||
                    resolvedParentId ||
                    "",

                  inNo: rmbInfoObj.inNo || "",

                  inDt: rmbInfoObj.inDt
                    ? moment(rmbInfoObj.inDt).format("DD-MM-YYYY")
                    : "",

                  pmtDt: isRmbObj.pmtDt
                    ? moment(isRmbObj.pmtDt).format("DD-MM-YYYY")
                    : "",

                  cur: isRmbObj.crId?.lab || isRmbObj.crId?.val || "",

                  amt: isRmbObj.amt !== undefined ? isRmbObj.amt : "",

                  cnvRt: isRmbObj.cnvRt !== undefined ? isRmbObj.cnvRt : "",

                  inr: isRmbObj.inr !== undefined ? isRmbObj.inr : "",
                },
              ]
            : [];

        return {
          ...record,
          poNo: poNo,

          oDt: record.oDt ? moment(record.oDt).format("DD-MM-YYYY") : "",
          oM: record.oM ? moment(record.oM).format("DD-MM-YYYY") : "",
          sub: record.invSub || "",
          pymtTerms:
            record.dlDt && record.oDt
              ? moment(record.dlDt)
                  .startOf("day")
                  .diff(moment(record.oDt).startOf("day"), "days")
              : 0,
          ofcId: "",
          rmks: record.rmks || "",
          cId: record.clId?.clName || "",
          pId: record.prId?.prj || "",
          cur: "INR",
          txId: record.clId?.gsts?.[0]?.gstNo || record.clId?.pnNo || "",
          mjId: record.mjId?.lab || record.mjId?.val || "",
          mnId: record.mnId?.lab || record.mnId?.val || "",
          vId: record.mrId?.name || record.mnId?.val || "",
          gstNo: record.mrId?.gsts?.[0]?.gstNo ?? "",

          subMnId: record.msId?.lab || record.msId?.val || "",
          sts: STATUS[record.pyInfo?.sts] || "approved",
          stsDate: record.oDt
            ? moment(record.oDt).format("DD-MM-YYYY")
            : moment().format("DD-MM-YYYY"),

          adjAmt: record.adjAmt || "",
          // Dynamic sub-array properties
          items: formattedItems,
          inv: formattedInvoice,

          payments: formattedPayments,
          taxes: formattedTaxes,
          tds: formattedTds,
          credits: formattedCredits,
          refunds: formattedRefunds,
          freightExpense: formattedFreight,
          reimbursementInfo: formattedReimbursement,
        };
      });

      return { mainCols, childSheets, records: flattenedRecords };
    },
    [handleExportExpenseApi, mainCols, childSheets, addToast],
  );

  return {
    handleGetFreshColumns,
    handleExportExpenseApi,
  };
};

export default useExpenseExport;
